import BaseDataService from "./base-data-service";
export default class ASPCoreReportDataService extends BaseDataService {
    constructor(baseUrl) {
        super(baseUrl);
        this.uri = {
            ...this.uri,
            reportData: "GetData",
            baseData: "BaseData",
            check: "check",
            getSettings: "GetSettings",
            saveData: "SaveData",
            changeCmpx: "ChangeReprCmpx",
            sign: "SignReport",
            previewRepText: "PreviewMedicalReport",
            previewDerivedParams: "PreviewDerivedParams",
            setStimulator: "SetStimulator",
            reqRRHR: "CalcRRHROnInterval",
            ping: "Ping",
            about: "About"
        };
    }

    // GET DATA________________________

    getProductInfo = async () => {
        let url = new URL(this.uri.baseUrl + this.uri.about);
        const reqRes = await fetch(url).then(resp => {
            if (resp.ok) {
                return resp.json();
            }
            throw new Error("ERROR. Couldn't get url settings");
        });

        return reqRes;
    };

    getSettings = async () => {
        let url = new URL(this.uri.baseUrl + this.uri.getSettings);
        const reqRes = await fetch(url, this._authHeader()).then(resp => {
            if (resp.ok) {
                return resp.json();
            }
            throw new Error("ERROR. Couldn't get url settings");
        });

        return reqRes;
    };

    check = async () => {
        let url = new URL(this.uri.baseUrl + this.uri.check);
        const sp = url.searchParams;
        this._addCommonSearchParams(sp);

        const reqRes = await fetch(url, this._authHeader()).then(resp => {
            if (resp.ok) {
                return resp.text();
            }
            throw new Error("ERROR. Check exam file and result");
        });

        try {
            const objRes = JSON.parse(reqRes);
            return objRes;
        } catch (e) {
            return false;
        }
    };

    getBaseData = async () => {
        let url = new URL(this.uri.baseUrl + this.uri.baseData);
        const sp = url.searchParams;
        this._addCommonSearchParams(sp);

        return fetch(url, this._authHeader()).then(resp => {
            if (resp.ok) {
                return resp.json();
            }
            throw new Error("ERROR. Get exam baseUrl data.");
        });
    };

    saveData = async data => {
        let url = new URL(this.uri.baseUrl + this.uri.saveData);
        const sp = url.searchParams;
        this._addCommonSearchParams(sp);
        return fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json;charset=utf-8",
                ...this._authHeader().headers
            },
            body: JSON.stringify(data)
        }).then(resp => {
            if (resp.ok) {
                return resp.json();
            }
            throw new Error("ERROR. Get save report data.");
        });
    };

    previewDerivedParams = async (data, from_pnt, to_pnt) => {
        let url = new URL(this.uri.baseUrl + this.uri.previewDerivedParams);
        const sp = url.searchParams;
        this._addCommonSearchParams(sp);
        this._addOtherUserParams(sp);
        sp.append("from_pnt", from_pnt);
        sp.append("to_pnt", to_pnt);

        return fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json;charset=utf-8",
                ...this._authHeader().headers
            },
            body: JSON.stringify(data)
        }).then(resp => {
            if (resp.ok) {
                return resp.json();
            }
            throw new Error("ERROR. Get report data.");
        });
    };
    req_RRHR_onInterval = async (from_pnt, to_pnt, reprCmpxIndex) => {
        let url = new URL(this.uri.baseUrl + this.uri.reqRRHR);
        const sp = url.searchParams;
        this._addCommonSearchParams(sp);
        this._addOtherUserParams(sp);
        sp.append("from_pnt", from_pnt);
        sp.append("to_pnt", to_pnt);
        sp.append("reprCmpxIndex", reprCmpxIndex);

        return fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json;charset=utf-8",
                ...this._authHeader().headers
            }
        }).then(resp => {
            if (resp.ok) {
                return resp.json();
            }
            throw new Error("ERROR. Get report data.");
        });
    };

    previewMedicalReport = async data => {
        let url = new URL(this.uri.baseUrl + this.uri.previewRepText);
        const sp = url.searchParams;

        sp.append("_lang", this.lang);
        this._addCommonSearchParams(sp);
        this._addOtherUserParams(sp);

        return fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json;charset=utf-8",
                ...this._authHeader().headers
            },
            body: JSON.stringify(data)
        }).then(resp => {
            if (resp.ok) {
                return resp.json();
            }
            throw new Error("ERROR. Get report data.");
        });
    };

    changeReprCmpx = async data => {
        let url = new URL(this.uri.baseUrl + this.uri.changeCmpx);
        const sp = url.searchParams;

        this._addCommonSearchParams(sp);
        return fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json;charset=utf-8",
                ...this._authHeader().headers
            },
            body: JSON.stringify(data)
        }).then(resp => {
            if (resp.ok) {
                return resp.json();
            }
            throw new Error("ERROR. Get change representative cmpx.");
        });
    };

    reqSetStimulator = async stimulator => {
        let url = new URL(this.uri.baseUrl + this.uri.setStimulator);
        const sp = url.searchParams;

        this._addCommonSearchParams(sp);
        sp.append("stimulator", stimulator);

        return fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json;charset=utf-8",
                ...this._authHeader().headers
            }
        }).then(resp => {
            if (resp.ok) {
                return resp.json();
            }
            throw new Error("ERROR. Request set stimulator.");
        });
    };

    signReport = async () => {
        let url = new URL(this.uri.baseUrl + this.uri.sign);
        const sp = url.searchParams;
        this._addCommonSearchParams(sp);

        return fetch(url, {
            method: "POST",
            headers: {
                ...this._authHeader().headers
            }
        }).then(resp => {
            if (resp.ok) {
                return resp.json();
            }
            throw new Error("ERROR. Request sign report.");
        });
    };

    _authHeader = () => {
        if (this.bearerToken)
            return {
                headers: {
                    Authorization: ` Bearer ${this.bearerToken}`
                }
            };
        else
            return {
                headers: {}
            };
    };
}
